/**
 * AUTO-GENERATED by scripts/write-auth-api-key.js - do not edit by hand.
 * Source: repo-root .env AUTH_API_KEY (never commit real secrets).
 */
export const AUTH_API_KEY = "6fe36be7-bd42-41ff-b1e7-84a74823a735";
